import React from 'react';
import InputGroup from './InputGroup';
import Input from './Input';

function PrependInput({ name, prefix, value, onChange }) {
    return (
        <InputGroup label={prefix}>
            <Input size="sm" name={name} value={value} onChange={onChange} />
        </InputGroup>
    );
}

export default PrependInput;
